import ApplyPage from "./ApplyPage";

const QUESTIONS = [
    {
        id: "tenure",
        label: "Как долго команда работает вместе?",
        placeholder: "Несколько месяцев, год, несколько лет.",
    },
    {
        id: "trigger",
        label: "Что именно заставило вас задуматься, что контроль потерян?",
        placeholder: "Сроки летят, релизы непредсказуемы, фокус потерян — опишите коротко.",
    },
    {
        id: "impact",
        label: "Ситуация уже влияет на бизнес или вы хотите разобраться заранее?",
        placeholder: "Несколько строк — этого достаточно.",
    },
    {
        id: "extra",
        label: "Что-то ещё хотите добавить?",
        placeholder: "Контекст, ограничения, особенности — любое полезное.",
    },
];

export default function ApplyControlPage() {
    return (
        <ApplyPage
            testid="apply-control"
            eyebrow="Формат 02 · Вернуть контроль"
            title={
                <>
                    Несколько вопросов{" "}
                    <span className="font-semibold">перед встречей</span>
                </>
            }
            intro="Пожалуйста, опишите коротко, что вас не устраивает в работе команды. Ваши ответы помогут мне подготовиться к нашей встрече."
            packageName="Вернуть контроль"
            questions={QUESTIONS}
            emailLabel="Ваш email, чтобы я могла связаться с вами *"
        />
    );
}
